import { render, staticRenderFns } from "./fullsize.vue?vue&type=template&id=6c319fda"
import script from "./fullsize.vue?vue&type=script&lang=js"
export * from "./fullsize.vue?vue&type=script&lang=js"
import style0 from "../mixins.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./fullsize.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports